import { useLocation, useRouteLoaderData } from '@remix-run/react';
import { CAMPAIGN_PATHS } from '~/common/constants/gatedRoutes';

type RootEnv = {
  ENV?: { REGIONS_ENABLED?: boolean; EU_EARLY_ACCESS?: boolean };
};

const useRootEnv = () =>
  (useRouteLoaderData('root') as RootEnv | undefined)?.ENV;

// Reads the resolved regions flag from the root loader so SSR and CSR see the
// same value. Do NOT swap this for `window.ENV.REGIONS_ENABLED` — `window` is
// undefined on the server and the isBrowser gate causes hydration mismatches
// and layout shift on every page load.
export const useRegionsEnabled = (): boolean => {
  const { pathname } = useLocation();
  const env = useRootEnv();

  // EU launch early access shows the picker on the launch pages only; the rest of
  // the site keeps today's UI until regions go on globally.
  return (
    env?.REGIONS_ENABLED === true ||
    (env?.EU_EARLY_ACCESS === true &&
      pathname.startsWith(CAMPAIGN_PATHS.euLaunch.gate))
  );
};

/** EU launch early access: this shopper prices in the EU market on every page. */
export const useEuEarlyAccess = (): boolean =>
  useRootEnv()?.EU_EARLY_ACCESS === true;
